import { useEffect } from 'react';
import { LogoPCB } from '../../assets/logo/LogoPCB'
import { useState } from 'react';
import LanguageSwitch from '../header/switchLanguages/LanguageSwitch';
import { useTranslation } from 'react-i18next';
import { useHistory , useParams } from 'react-router-dom';
import { HeaderWrapper } from './HeaderWrapperStyles';


const Header = () => {
    
const history = useHistory()
const {lang} = useParams()
const { i18n } = useTranslation();
const pathname = history.location.pathname;
const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('culture', lang);
    history.push(`/${lang}`)
  };
    return (
        <HeaderWrapper>
        <div>
            <LogoPCB />
        </div>
        <div className='right'>
        <LanguageSwitch
            changeLanguage={changeLanguage}
            currentLanguageCode={lang}
          />
          </div>
        </HeaderWrapper>
    );
};
export default Header;